<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: "fileLists",
  
})
</script>
<template>
	<div class="fileLists">
		<!-- 多文档 -->
		<div v-if="inversion && uploadList && uploadList.length" class="rightBottom" :class="[question.trim() ? 'marginTop' : '']">
			<div class="box-lists" :style="{ width: getWidth }" :class="{isMobileList:isMobile}">
				<div class="result-item" :class="[isMobile ? 'item-mobile' : 'pc-item']" v-for="(item, key) in uploadList" :key="key" @click="previewFile(item)">
					<div class="content-box">
						<div class="box-left">
							<component :is="getIcon(item.type)" size="36" v-if="item.type"></component>
						</div>
						<div class="box-right fontFam">
							<div class="right-name">{{ item.name || item.url }}</div>
							<div class="right-url">{{ $t('chat.center.about', { num: item.wordsCount }) }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 多图片 -->
		<div v-if="inversion && imgList && imgList.length" class="rightBottom" :class="[question&&!uploadList.length ? 'marginTop' : '']">
			<div class="img-lists" :style="{ width: getWidth}"  :class="{isImgList:isMobile}">
				<div class="img-item" v-for="(item, key) in imgList" :key="key" @click="previewFile(item)">
					<img  :src="item.url" @dragstart="preventImageDrag"/>
				</div>
				<!-- <w-image-preview-group infinite>
					<w-space :style="{ width: getWidth }">
						<w-image :src="item.url" width="150" v-for="(item, key) in imgList" :key="key" />
					</w-space>
				</w-image-preview-group> -->
			</div>
		</div>
		<w-modal v-model:visible="imgPreVisible" :footer="false" hide-cancel modal-class="imgPreModal" :width="isMobile ? '90%' : 640">
			<template #title>
				{{ imgPreData.name }}
			</template>
			<div class="img-box">
				<img :src="imgPreData.url" @dragstart="preventImageDrag"/>
			</div>
		</w-modal>
	</div>
</template>
<script lang="ts" setup name="fileLists">
import { onMounted, ref, computed } from 'vue';
import { useChatStore } from '/@/stores/chat';
import { useBasicLayout } from '/@common/hooks/useBasicLayout';
import { useRoute } from 'vue-router';
import DSBridge from '/@common/utils/dsBridge/dsBridge';
const route = useRoute();
const { isMobile } = useBasicLayout();
interface Props {
	inversion?: boolean;
	question: string;
	files?: [];
	width?: number;
	from?: string;
}
const imgPreVisible = ref(false);
const chatStore = useChatStore();
const uploadList = ref([]);
const imgList = ref([]);
const imgPreData = ref({});
const props = defineProps<Props>();
const getIcon = (icon: string) => {
	const iconMap = {
		txt: 'CoolTxt',
		docx: 'CoolDocx',
		doc: 'CoolDocx',
		pdf: 'CoolPdf',
		web: 'CoolLianjie',
		jpg: 'CoolLianjie',
		jpeg: 'CoolLianjie',
		png: 'CoolLianjie',
		ppt:'CoolPPT',
		pptx:'CoolPPT',
		xls:'CoolExcel',
	  xlsx:'CoolExcel',
	  csv:'CoolExcel',
	};
	return iconMap[icon];
};
const getWidth = computed(() => {
	let shareId = route.params.shareId || '';
	if (isMobile.value||props.from=='debug') {
		return 'auto';
	} else {
		return '100%';
	}
});
const preventImageDrag = (event) => {
  event.preventDefault(); // 阻止默认行为
};
const previewFile = (item: object) => {
	if (DSBridge.isDSBridgeEnvironment()) {
		DSBridge.callNative('triggerFiles', item)
		return 
	}
	chatStore.previewFlag=true
	chatStore.previdewData=item
};
onMounted(() => {
	if (props.files) {
		let typeList = ['png', 'jpg', 'jpeg', 'PNG', 'JPG', 'JPEG'];
		if (props.files && props.files.length) {
			uploadList.value = props.files.filter((item: any) => !typeList.includes(item.type));
			imgList.value = props.files.filter((item: any) => typeList.includes(item.type));
		}
	}
});
</script>
<style lang="scss" scoped>
@mixin text() {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.fileLists{
	width:100%;
}
.rightBottom {
	position: relative;
	height: auto;
	.iconfold {
		position: absolute;
		left: -10px;
		z-index: 100;
	}
	.img-lists {
		  display: flex;
			flex-wrap: wrap;
			justify-content: flex-end;
		:deep(.w-space){
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-end;
			.w-space-item{
				height: 91px;
				margin-bottom: 10px;
				margin-right: 10px;
				&:last-child{
					margin-right: 5px;
				}
				.w-image{
					height: 91px;
					margin-bottom: 10px;
					img{
						width:122px;
						height: 100%;
						border-radius: 7px;
            border: 1px solid #E4E8EE;
						object-fit: cover;
					}
				}
				
			}
		}
		.img-item {
			cursor: pointer;
			margin-right: 8px;
			margin-bottom: 10px;
			height: 91px;
			&:last-child{
					// margin-right: 0px !important;
				}
			img {
				width:150px;
				height: 100%;
				border-radius: 7px;
        border: 1px solid #E4E8EE;
				object-fit: cover;
			}
			.w-image-img {
				border-radius: 8px;
			}
		}
	}
	.isImgList{
		img{
			width:100px !important;
		}

	}
	.box-lists {
		// display: flex;
		// flex-wrap: wrap;
		// justify-content: flex-end;
		// max-width: 820px;
		margin-bottom: 8px;
		display: grid;
      grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
      grid-template-rows: repeat(auto-fill, minmax(52px));
	  direction: rtl;
      gap: 8px;
	  gap: 8px;
		.result-item {
			direction: ltr;
			// width: calc(33.3% - 6px);
			// flex:1;
			cursor:pointer;
			// min-width:200px;
			// max-width: 244px;
			height: 52px;
			// margin-right: 5px;
			background: #ffffff;
			border-radius: 8px;
			padding: 5px;
			// margin-bottom: 10px;
			border: 1px solid rgba(228, 232, 238, 0);
			position: relative;
			width:100%;
			.content-box {
				display: flex;
				.box-left {
					margin-right: 8px;
				}
				.box-right {
					width: calc(100% - 44px);
					.right-name {
						@include text;
						font-size: var(--font14);
						color: #3d485d;
					}
					.right-url {
						@include text;
						font-size: var(--font12);
						color: #9a99aa;
					}
				}
			}
			&:hover .delete-icon {
				display: block;
			}
		}
		// .item-mobile {
		// 	width: calc(50% - 6px);
		// 	min-width: 140px;
		// }
		// .pc-item{
		// 	min-width: 180px;
		// }
	}
	.isMobileList{
		grid-template-columns: repeat(auto-fill, minmax(145px, 1fr));
	}
}
.marginTop {
	margin-top: 12px;
}
</style>
<style lang="scss">
.imgPreModal {
	.w-modal-header {
		padding: 22px 24px !important;
	}
	.w-modal-title-align-center {
		font-weight: 400 !important;
		font-size: var(--font18) !important;
		color: #181b49 !important;
	}
	.w-modal-title-align-center .w-modal-close-btn {
		font-size: var(--font22) !important;
	}
	.w-modal-body {
		max-width: 100%;
		width: 640px;
		min-height: 300px;
		display: flex;
		justify-content: center;
	}
	.img-box {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		img {
			display: inline-block;
			max-width: 100%;
			height: auto;
		}
	}
}
</style>
